import { DropdownButton, StandardButton, TaskDropdownButton } from "../atoms/buttons";
import { DateInputForm, InputForm, TextAreaForm} from "../atoms/input";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "./modal";
import { Alert } from "../components/alert";
import { use, useContext, useEffect, useState } from "react";
import { getAPI, postAPI, updateAPI } from "../api/api";
import { set } from "date-fns";
import { ToastContext } from "../App";
import { VerticalPageLayout } from "./layout";
import { Spinner } from "../atoms/spinner";

const TaskModal = ({ visible, dismiss, title, children, buttonTitle, handleSave, cancel }) => {
    
    return (
        <Modal hidden={false} height={null} visible={visible} dismissable={dismiss}>
            <ModalTitle title={title} hasXmark={true} dismissable={dismiss} />
                <ModalBody>
                    {children}
                </ModalBody>
            <ModalFooter>
                <FooterButton handleSave={handleSave} title={buttonTitle} cancel={cancel} dismiss={dismiss}/>
            </ModalFooter>             
        </Modal>
    );
};

// export const AddTask = ({visible, dismiss, buttonTitle}) => {
//     const [data, setData] = useState({
//     title: "",
//     beschrijving: "",
//     action: "",
//     date: "",
//     actionLead: "",
//     selected: false
//     });

//     const titleChange = (userinput) => setData(prev => ({ ...prev, title: userinput }));
//     const beschrijvingChange = (userinput) => setData(prev => ({ ...prev, beschrijving: userinput }));
//     const dateChange = (newDate) => setData(prev => ({ ...prev, date: newDate }));    

//     // const [dropDownActions, setDropDownActions] = useState([
//     // { id: "0", content: "E-mail versturen", selected: false },
//     // { id: "1", content: "Bellen", selected: false },
//     // { id: "2", content: "Afspraak maken", selected: false },
//     // { id: "3", content: "Demo", selected: false },
//     // { id: "4", content: "Kopje koffie inplannen", selected: false }
//     // ]);

//     const [dropDownActions, setDropDownActions] = useState([
//     { id: "0", content: "E-mail versturen" },
//     { id: "1", content: "Bellen" },
//     { id: "2", content: "Afspraak maken" },
//     { id: "3", content: "Demo" },
//     { id: "4", content: "Kopje koffie inplannen" }
//     ]);

//     const actionOnChange = (id, multiSelect) => {
//     setDropDownActions(prev =>
//         prev.map(option => ({
//         ...option,
//         selected: option.id === id
//             ? multiSelect ? !option.selected : true
//             : multiSelect ? option.selected : false
//         }))
//     );
//     };

//     const handleSave = () => {
//     const selectedActions = dropDownActions.filter(o => o.selected);
//     const selectedIds = selectedActions.map(a => a.id);
//     const selectedLabels = selectedActions.map(a => a.content);
//     alert(
//         "Selected IDs: " + selectedIds.join(", ") + 
//         "\nSelected Actions: " + selectedLabels.join(", ")
//     );
//     };

//     return (
//         <TaskModal type={"addTask"} title = {"Nieuwe taak toevoegen"} visible={visible} dismiss={dismiss} buttonTitle={buttonTitle} data={data } handleSave={handleSave}>
//         <InputForm title={"Title"} placeholder={"Add title"} typeInput={titleChange}/>
//         <InputForm title={"Beschrijving"} placeholder={"Beschrijving toevoegen"} typeInput={beschrijvingChange}/>
//         <TaskDropdownButton multiSelect={true} title={"Actie type"} dropdown={dropDownActions} buttonStyle={{width: "100%",marginBottom : "0.75rem", justifyContent: "space-between"}} marginLeft="unset" optionSelected={actionOnChange} dropdownStyle={{width: "100%", fontSize: "0.8rem", marginTop: "0.2rem"}}/>
//         <DateInputForm title={"Datum"} value={data.date} onChange={((e) => {dateChange(e)})}/>
//         <Alert className={"dynamic-phone-alert"} type={"warning"} message={"Deze taak wordt niet aan alle leads gekoppeld."} style={{width: "100%"}}/>
//         </TaskModal>
//     );
// };

export const UpdateTask = ({ visible, dismiss, task = {}, loadTasks }) => {
    const toastContext = useContext(ToastContext);

    const [data, setData] = useState({
        title: "",
        description: "",
        date: "",
    });

    useEffect(() => {
        if (!visible || !task?.id_task) return;

        setData({
            title: task.title || "",
            description: task.description || "",
            date: task.date
                ? task.date.split("-").reverse().join("-")
                : new Date().toISOString().slice(0, 10),
            
        });
    }, [visible, task]);

    const titleChange = (value) =>
        setData(prev => ({ ...prev, title: value }));

    const descriptionChange = (value) =>
        setData(prev => ({ ...prev, description: value }));

    const dateChange = (value) =>
        setData(prev => ({ ...prev, date: value }));

    const handleSave = async () => {
        if (!data.title || !data.date) {
            return toastContext.showToast(
                <>Alle velden moeten worden ingevuld.</>,
                "error",
                3000
            );
        }

        const query = "api/tasks/update";
        const body = {
            id_task: task.id_task,
            title: data.title,
            description: data.description,
            start_date: data.date,
            manual: 1,
            task_status: task.status
        };
        console.log("body update task", body);

        const res = await updateAPI(query, body);

        if (res.status === "ok") {
            dismiss();
            loadTasks();
            toastContext.showToast(
                <>Taak succesvol bijgewerkt.</>,
                "success",
                2500
            );
        }
    };

    return (
        <TaskModal
            title={"Taak bewerken"}
            visible={visible}
            dismiss={dismiss}
            buttonTitle={"Opslaan"}
            handleSave={handleSave}
        >
            <InputForm
                title={"Titel"}
                value={data.title}
                placeholder={"Titel aanpassen"}
                typeInput={titleChange}
            />

            <InputForm
                title={"Beschrijving"}
                value={data.description}
                placeholder={"Beschrijving aanpassen"}
                typeInput={descriptionChange}
            />

            <DateInputForm
                title={"Datum"}
                value={data.date}
                onChange={dateChange}
            />
        </TaskModal>
    );
};


export const AddTask = ({ visible, dismiss, loadTasks, selectedTemplateStep }) => {
    const [data, setData] = useState({
        title: "",
        description: "",
        actionId: [],
        date: new Date().toISOString().split("T")[0], 
    });
    const [dropdownOptions, setDropdownOptions] = useState([])
    const toastContext = useContext(ToastContext);
    const loadActions = async () => {
        const query = "api/tasks/actions";
        const res = await getAPI(query);

        if (res.status !== "ok") return;

        let actions = res.data;
        if (selectedTemplateStep?.actions?.length) {
            actions = actions.filter(action =>
                selectedTemplateStep.actions.includes(action.id_action)
            );
        }

        const options = actions.map(action => ({
            id: action.id_action,
            content: (
                <div style={{ display: "flex", gap: ".25rem", alignItems: "center" }}>
                    {action.title}
                    {action.step_title && (
                        <span className="standard-text-color-light" style={{ fontSize: ".7rem" }}>
                            ({action.step_title})
                        </span>
                    )}
                </div>
            )
        }));

        setDropdownOptions(options);
    };
    useEffect(() => {
        if (!visible) return;
        loadActions();
    }, [visible, selectedTemplateStep]);

    const titleChange = (userinput) => setData(prev => ({ ...prev, title: userinput }));
    const descriptionChange = (userinput) => setData(prev => ({ ...prev, description: userinput }));
    const dateChange = (newDate) => {
        const formatted = newDate instanceof Date ? newDate.toISOString().split("T")[0] : newDate;
        setData(prev => ({ ...prev, date: formatted }));
    };
    const dropdownChange = (selectedOptions) => {
        const selectedIds = selectedOptions.map(o => o.id);
        setData(prev => ({
            ...prev,
            actionId: selectedIds
        }));
    }
    const handleSave = async () => {
        if(!data.title || !data.date) {
            return toastContext.showToast(<>Alle velden moeten worden ingevuld.</>, "error", 3000)
        }
        const query = "api/tasks/add";
        const body = {
            title: data.title,
            description: data.description,
            id_action: data.actionId[0],
            start_date: data.date,
        }
        console.log("body", body);
        const res = await postAPI(query, body);
        if(res.status === "ok"){
            dismiss();
            loadTasks();
        }
    };
  return (
    <TaskModal type={"addTask"} title={"Nieuwe taak toevoegen"} visible={visible} dismiss={dismiss} buttonTitle={"Opslaan"} data={data} handleSave={handleSave}>
      <InputForm title={"Title"} placeholder={"Add title"} typeInput={titleChange}/>
      <InputForm title={"Beschrijving"} placeholder={"Beschrijving toevoegen"} typeInput={descriptionChange}/>
      {/* <TaskDropdownButton onChange={dropdownChange} multiSelect={false} title={"Actie"} setDropdownOptions={setDropdownOptions} dropdown={dropdownOptions} buttonStyle={{ width: "100%", marginBottom: "0.75rem", justifyContent: "space-between" }} optionStyle={{ fontSize: "0.8rem" }} dropdownStyle={{ width: "100%", marginTop: "0.2rem" }}/> */}
      <DateInputForm title={"Datum"} value={data.date} onChange={dateChange}/>
      <Alert className={"dynamic-phone-alert"} type={"warning"} message={"Deze taak wordt niet aan alle leads gekoppeld."} style={{ width: "100%" }}/>
    </TaskModal>
  );
};


export const AddLeadToTask = ({visible, selectedLeads, id_task, dismiss, buttonTitle, load}) => {
    const [data, setData] = useState({
        id_leads: null,
        id_task: id_task,
    });
    const [loading, setLoading] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const loadLeads = async () => {
        setLoading(true);
        const query = "api/leads/leads"
        const res= await getAPI(query)
        console.log("res leads in add lead to task", res);
        if(res.status === "ok"){
            const content = (lead) => {
                const name = [lead.first_name, lead.last_name].filter(Boolean).join(" ");
                return name || lead.email || lead.company_name || "Onbekende lead";
            };
            const selectedLeadIds = new Set(
                (selectedLeads || []).map(l => l.id_lead)
            );
                setDropDownOptions(
                    res.data
                    .filter(lead => lead.id_lead)
                    .filter(lead => !selectedLeadIds.has(lead.id_lead))
                    .map(lead => ({
                        id: lead.id_lead,
                        content: content(lead),
                        selected: false,
                    }))
            );
        }
        setLoading(false);

    }

    const handleDropdownChange = (selectedOptions) => {
        setData(prev => ({
            ...prev,
            id_leads: selectedOptions.map(o => o.id),
        }));
    };
    const [dropDownOptions, setDropDownOptions] = useState([]);

    useEffect(() => {
        if (!visible) return;
        loadLeads();
        setData(prev => ({
            ...prev,
            id_task: id_task,
        }));
    }, [visible]);
    const handleSave = async () => {
        const query = "api/tasks/asign-lead";
        const body ={ id_task: data.id_task, id_leads: data.id_leads, }
        const res = await postAPI(query, body)
        if(res.status === "ok"){
            dismiss();
            load()
        }
    };
    if(loading)return<></>
    return (
        <TaskModal type={"addLeadTask"} title = {"Lead aan taak toevoegen"} visible={visible} dismiss={dismiss} buttonTitle={buttonTitle} handleSave={handleSave} cancel={dropDownOptions.length === 0}> 
            {dropDownOptions.length > 0 && !loading && <TaskDropdownButton  isOpen={dropdownOpen} onToggle={() => setDropdownOpen(prev => !prev)} setDropdownOptions={setDropDownOptions} multiSelect={true} title={"Leads koppelen"} dropdown={dropDownOptions} buttonStyle={{ width: "100%", marginBottom: "0.75rem", justifyContent: "space-between" }} optionStyle={{ fontSize: "0.8rem" }} dropdownStyle={{ width: "100%", marginTop: "0.2rem" }} onChange={handleDropdownChange}/>}       
            {dropDownOptions.length === 0 && !loading && <Alert message={"Geen leads beschikbaar om toe te voegen."} type={"info"} />}
        </TaskModal>
    );
};

export const AddTaskToLead = ({visible, dismiss, buttonTitle, lead={}, load}) => {
    const [data, setData] = useState({
        title: "",
        description: "",
        start_date: new Date().toISOString().slice(0, 10),
        leadData: {},
        note: ""
    });
    console.log("lead in modal", lead);
    const titleChange = (userinput) => setData(prev => ({ ...prev, title: userinput }));
    const descriptionChange = (userinput) => setData(prev => ({ ...prev, description: userinput }));
    const dateChange = (newDate) => setData(prev => ({ ...prev, start_date: newDate }));
    useEffect(() => {
        setData({
            ...data,
            title: "",
            description: "",
            start_date: new Date().toISOString().slice(0, 10),
            leadData: lead,
            note: ""
        });
    }, [lead]);
    const handleSave = async () => {
        console.log("data to save", data);
        const query = "api/tasks/asign-task/lead";
        const body ={
            title: data.title, 
            description: data.description, 
            start_date: data.start_date, 
            id_lead: data.leadData.id_lead,
            note: data.note,
            task_connection: "connect_lead",
            manual: 1
        }
        console.log("body add task to lead", body);
        const res = await postAPI(query, body)
        console.log("res add task to lead", res);
        if(res.status === "ok"){
            dismiss();
            load();
        }
    };

    return (
        <TaskModal type={"addTaskLead"} title = {"Nieuwe taak toevoegen"} visible={visible} dismiss={dismiss} buttonTitle={buttonTitle} data={data} handleSave={handleSave}>
        <InputForm title={"Title"} placeholder={"Title toevoegen"}typeInput={titleChange}/>
        <InputForm title={"Beschrijving"} placeholder={"Beschrijving toevoegen"} typeInput={descriptionChange}/>
        <DateInputForm value={data.start_date} title={"Datum"} onChange={dateChange}/>
        <InputForm title={"Lead"} disabled={true} value={lead.first_name + " " + lead.last_name}/>
        <TextAreaForm title={"Notitie"} placeholder={"Notitie toevoegen"} typeInput={(userinput) => setData(prev => ({ ...prev, note: userinput }))}/>
        </TaskModal>
    );
};

export const AddTaskToCompany = ({visible, dismiss, buttonTitle, company={}, load}) => {
    const [data, setData] = useState({
        title: "",
        description: "",
        start_date: new Date().toISOString().slice(0, 10),
        companyData: {},
        note: ""
    });
    console.log("lead in modal", company);
    const titleChange = (userinput) => setData(prev => ({ ...prev, title: userinput }));
    const descriptionChange = (userinput) => setData(prev => ({ ...prev, description: userinput }));
    const dateChange = (newDate) => setData(prev => ({ ...prev, start_date: newDate }));
    useEffect(() => {
        setData({
            ...data,    
            title: "",
            description: "",
            start_date: new Date().toISOString().slice(0, 10),
            companyData: company,
            note: ""
        });
    }, [company]);
    const handleSave = async () => {
        const query = "api/tasks/asign-task/company";
        const body ={
            title: data.title, 
            description: data.description, 
            start_date: data.start_date, 
            id_lead_company: data.companyData.id_lead_company,
            note: data.note,
            task_connection: "connect_company",
            manual: 1
        }
        console.log("body add task to lead", body);
        const res = await postAPI(query, body)
        console.log("res add task to lead", res);
        if(res.status === "ok"){
            dismiss();
            load();
        }
    };

    return (
        <TaskModal type={"addTaskLead"} title = {"Nieuwe taak toevoegen"} visible={visible} dismiss={dismiss} buttonTitle={buttonTitle} data={data} handleSave={handleSave}>
        <InputForm title={"Title"} placeholder={"Title toevoegen"}typeInput={titleChange}/>
        <InputForm title={"Beschrijving"} placeholder={"Beschrijving toevoegen"} typeInput={descriptionChange}/>
        <DateInputForm value={data.start_date} title={"Datum"} onChange={dateChange}/>
        <InputForm title={"Bedrijf"} disabled={true} value={company?.name}/>
        <TextAreaForm title={"Notitie"} placeholder={"Notitie toevoegen"} typeInput={(userinput) => setData(prev => ({ ...prev, note: userinput }))}/>
        </TaskModal>
    );
};

const FooterButton = ({ title = "Opslaan" , handleSave, cancel, dismiss }) => {

    return (    
       cancel ? 
        <StandardButton
            title={"Terug"}
            className={"task-footer-button"}
            backgroundColor="var(--grey-200)"
            textColor="var(--standard-color-text)"
            onClick={() => dismiss()}
        />
        :
        <StandardButton
            title={title}
            className={"task-footer-button"}
            onClick={() => handleSave()}
        />
    )
};

